import React, { ReactNode } from 'react'

type Props = { children: ReactNode } & ({ hashPath: string } | { isDefault: boolean })

const HashPath = ({ children }: Props) => <>{children}</>

export default HashPath
